import { HorizontalBar } from 'vue-chartjs';
import { getTooltipTheme } from 'dashboard/helper/chartThemeHelper';
import rtlMixin from 'shared/mixins/rtlMixin';

/**
 * Used for the CSAT rating distribution — a single stacked bar. Both axes are
 * hidden, so the only themed surface is the tooltip, which Chart.js otherwise
 * draws as a black box with its own corner radius.
 */
const buildDefaults = isRTL => ({
  responsive: true,
  legend: { display: false },
  title: { display: false },
  tooltips: getTooltipTheme(isRTL),
  scales: {
    xAxes: [
      {
        gridLines: { offsetGridLines: false },
        display: false,
        stacked: true,
        // The segments of a stacked bar are laid out in dataset order along the
        // axis; in an RTL page that order has to start from the right.
        ticks: { reverse: isRTL },
      },
    ],
    yAxes: [
      {
        gridLines: { offsetGridLines: false },
        display: false,
        stacked: true,
      },
    ],
  },
});

export default {
  extends: HorizontalBar,
  mixins: [rtlMixin],
  props: {
    collection: {
      type: Object,
      default: () => ({}),
    },
    chartOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    collection() {
      this.draw();
    },
    chartOptions() {
      this.draw();
    },
  },
  mounted() {
    this.draw();
  },
  methods: {
    draw() {
      this.renderChart(this.collection, {
        ...buildDefaults(this.isRTLView),
        ...this.chartOptions,
      });
    },
  },
};
